import { trpc, type trpcClient } from '@client/trpc/client';

export type TrpcUtils = ReturnType<typeof trpc.useUtils>;

/**
 * The vanilla tRPC client. `useTrpc().trpcClient` is the same object as `trpcClient` from
 * `@client/trpc/client` (the provider is given it), so this is typed as that one: a migrated caller
 * passes the module client wherever a `TrpcClient` is taken.
 */
export type TrpcClient = typeof trpcClient;

export function useTrpc() {
    const utils = trpc.useUtils();

    return {
        trpc,
        trpcUtils: utils,
        trpcClient: utils.client,
    };
}
